<template>
    <div class="venue-registration-wrapper">
        <Stepper :steps="steps" @registrationComplete="handleSubmit" />
    </div>
</template>

<script>
    import axios from 'axios'
    import Stepper from '@/components/registration/parts/Stepper.vue'
    import VenueLocationRegistration from './VenueLocationRegistration.vue'
    import SoundBudget from './SoundBudget.vue'
    import CalendarPage from './CalendarForm.vue'
    import RegistrationForm from '../venue-profile-creation/steps/RegistrationForm.vue'

    export default {
        name: 'VenueEventRegistration',
        components: {
            Stepper
        },
        data() {
            return {
                steps: [
                    {
                        title: 'Register',
                        component: RegistrationForm
                    },
                    {
                        title: 'CLAIM VENUE',
                        component: VenueLocationRegistration
                    },
                    {
                        title: 'EVENT VIBE',
                        component: SoundBudget
                    },
                    {
                        title: 'SELECT DATES',
                        component: CalendarPage
                    }
                ]
            }
        },

        methods: {
            async handleSubmit(data) {
                let venueData = {}
                for (let key in data) {
                    if (
                        typeof data[key] === 'object' &&
                        !Array.isArray(data[key]) &&
                        data[key] !== null
                    ) {
                        Object.assign(venueData, data[key])
                    }
                }
                let response = await axios.post(
                    '/v1/venue-registration-events-store',
                    venueData
                )
                if (response.status === 201) {
                    localStorage.setItem('venueSlug', response.data.slug)
                    window.location.href =
                        '/v1/venues/' + response.data.slug + '/upcoming-events'
                }
            }
        },
        created() {
            localStorage.setItem('mode', 'eventCreation')
        }
    }
</script>

<style lang="scss" scoped>
    .venue-registration-wrapper {
        background-color: #121212;

        input:-webkit-autofill,
        input:-webkit-autofill:hover,
        input:-webkit-autofill:focus,
        input:-webkit-autofill:active {
            transition: background-color 5000s ease-in-out 0s;
            -webkit-text-fill-color: #fff !important;
        }
    }

    .pac-container {
        background: transparent;
        border: none;
    }
    .pac-icon {
        background-image: url(/images/icons/marker.png);
    }

    .pac-item {
        color: white;
    }
    .pac-item:hover {
        color: #d7eb5a;
        background: transparent;
        font-weight: bolder;
    }
    .pac-item-selected {
        color: #d7eb5a;
        background: transparent;
        font-weight: bolder;
    }
    .pac-item-query {
        background: transparent;
    }
    .pac-matched {
        color: #d7eb5a;
        font-weight: bolder;
    }
    .pac-item-selected .pac-icon-marker {
        background-position: center;
    }
</style>
